import { CustomButton } from '../components/Button'

import { i18n } from 'i18n-utils'
import { DefineComponentProps } from 'utils'

import { HocElDialog, HocElDialogFooterLayout } from '..'
import { DialogHeader } from '../components/DialogHeader'
import './CustomDialog.scss'

type CustomDialogProps = {
  title: string
  modelValue: boolean
  content: string | Component
  width?: number
  onClose?: () => void
  modal?: boolean
  confirmButtonText?: string
  cancelButtonText?: string
  showConfirm?: boolean
  onConfirm?: ((done: () => void) => Promise<void> | void) | (() => Promise<void> | void)
  closeOnClickModal?: boolean
  placement?: 'center' | 'bottom' | 'right'
  onCancel?: () => void
}

export const CustomDialog = defineComponent<CustomDialogProps>({
  props: DefineComponentProps<CustomDialogProps>([
    'content',
    'title',
    'modelValue',
    'width',
    'onClose',
    'modal',
    'confirmButtonText',
    'onConfirm',
    'closeOnClickModal',
    'placement',
    'cancelButtonText',
    'onCancel',
    'showConfirm',
  ]),
  setup(props) {
    const { closeOnClickModal = true, showConfirm = true } = props
    const { t } = i18n.global
    const dialogVisible = ref(props.modelValue)
    const loading = ref(false)
    const onClose = async () => {
      dialogVisible.value = false
      props.onClose?.()
    }

    const closeDialog = () => {
      dialogVisible.value = false
      props.onClose?.()
    }

    const onConfirm = async () => {
      if (props.onConfirm) {
        loading.value = true
        let rejected = false
        // 声明了 done 参数 → 由调用方手动控制关闭；否则自动关闭
        if (props.onConfirm.length > 0) {
          await Promise.resolve(props.onConfirm(closeDialog)).catch(() => (rejected = true))
          loading.value = false
          return
        }
        await Promise.resolve((props.onConfirm as () => Promise<void> | void)()).catch(() => (rejected = true))
        loading.value = false
        if (rejected) return
      }
      closeDialog()
    }

    const onCancel = () => {
      dialogVisible.value = false
      props.onCancel?.()
    }

    return () => (
      <div class="custom-dialog-layout">
        <HocElDialog
          modelValue={dialogVisible.value}
          width={props.width || 430}
          showClose={false}
          modal={props.modal}
          closeOnClickModal={closeOnClickModal}
          placement={props.placement}
        >
          {{
            header: () => <DialogHeader onClose={onClose}>{props.title}</DialogHeader>,
            default: () => (
              <div class={'dialog-content'}>
                <div class="dialog-content-container">{props.content}</div>
              </div>
            ),
            footer: () =>
              (showConfirm || props.cancelButtonText) && (
                <HocElDialogFooterLayout class="flex gap-2 items-center justify-center">
                  {props.cancelButtonText && (
                    <CustomButton type={'default'} class={'confirm-button'} onClick={onCancel}>
                      {props.cancelButtonText}
                    </CustomButton>
                  )}
                  {showConfirm && (
                    <CustomButton type={'primary'} class={'confirm-button'} onClick={onConfirm} loading={loading.value}>
                      {t(props.confirmButtonText || '确定')}
                    </CustomButton>
                  )}
                </HocElDialogFooterLayout>
              ),
          }}
        </HocElDialog>
      </div>
    )
  },
})
